import config from '../../config';

export const authenticateLegacy = async (
  client,
  documentId,
  appSessionId,
  sessionId
) => {
  //ask the server for an authentication token based on scribonline login
  return fetch(`${config.lambdaUrl}/legacy/authenticate`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      client,
      documentId,
      appSessionId,
      sessionId
    })
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      return response.json();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};
